import React from 'react';
import { connect } from 'react-redux'
import moment from "moment-timezone";

class StatusHistory extends React.Component {

	render () {

        const formatDate = (date) => {
            if (!date) return '';

            const baseDate = new Date(date);

            return this.props.tz
                ? moment.tz(baseDate, this.props.tz).format('M/D/YYYY h:mm A z')
                : moment(baseDate).format('M/D/YYYY h:mm A');
        };

		var history = [];
		this.props.history.map( function(value,index) {
		if(value.is_note == 0){
			if (value.user){
				var jsx = <h6 key={index} className="status-p pb-1 pt-1 pl-2 pr-2 mb-0 d-block d-sm-flex text-default"><span>{(value.user.firstname?value.user.firstname:"") + " " + (value.user.lastname?value.user.lastname:"") + " "}</span> 	&nbsp;<span className="d-none d-sm-inline-block">{ __('changed the status') }</span><span className="card-dot-sm card-dot ml-1 d-none d-sm-inline-block"></span><b>{value.status}</b>  <br className="d-sm-none"/><span className="ml-auto">{formatDate(value.created_at)}</span></h6>
			} else if (value.status === 'Resolved') {
				// User-less rows come from two system writers: the incoming-message reopen (always Open) and auto-resolve-all (always Resolved).
				var jsx = <h6 key={index} className="status-p pb-1 pt-1 pl-2 pr-2 mb-0 d-block d-sm-flex text-default"><span>Auto-Resolve</span> 	&nbsp;<span className="d-none d-sm-inline-block">{ __('changed the status') }</span><span className="card-dot-sm card-dot ml-1 d-none d-sm-inline-block"></span><b>{value.status}</b>  <br className="d-sm-none"/><span className="ml-auto">{formatDate(value.created_at)}</span></h6>
			} else {
				var jsx = <h6 key={index} className="status-p pb-1 pt-1 pl-2 pr-2 mb-0 d-block d-sm-flex text-default"><span>{ __('Automatic Status Update Due To Incoming Message') }</span><span className="card-dot-sm card-dot ml-1 d-none d-sm-inline-block"></span><b>{value.status}</b>  <br className="d-sm-none"/><span className="ml-auto">{formatDate(value.created_at)}</span></h6>
			}
		} else {
			if(value.note && value.note.user_id){
				var name = (value.user && value.user.firstname ? value.user.firstname : "") + " " + (value.user && value.user.lastname ? value.user.lastname : "") + " ";
				var jsx = <h6 key={index} className="status-p pb-1 pt-1 pl-2 pr-2 mb-0 d-block d-sm-flex text-default"><span>{name}</span> 	&nbsp;<span className="d-none d-sm-inline-block">Added a note</span><span className="card-dot-sm card-dot ml-1 d-none d-sm-inline-block"></span><b>{(value.note.note.length > 30 ? value.note.note.substring(0, 30)+"..." : value.note.note)}</b>  <br className="d-sm-none"/><span className="ml-auto">{formatDate(value.created_at)}</span></h6>
			} else if(value.note && !value.note.user_id) {
				var name = value.note.user_name + " (External)";
				var jsx = <h6 key={index} className="status-p pb-1 pt-1 pl-2 pr-2 mb-0 d-block d-sm-flex text-default"><span>{name}</span> 	&nbsp;<span className="d-none d-sm-inline-block">Added a note</span><span className="card-dot-sm card-dot ml-1 d-none d-sm-inline-block"></span><b>{(value.note.note.length > 30 ? value.note.note.substring(0, 30)+"..." : value.note.note)}</b>  <br className="d-sm-none"/><span className="ml-auto">{formatDate(value.created_at)}</span></h6>
			} else {
				var jsx = null;
			}

		}
			if(jsx){
				history.push(jsx);
			}
		});
		if (this.props.history.length > 0) {
			return (
			<div className="col-sm-12 mb-3 status-history anim-slide-in-top">
				{history}
			</div>
			 );

		} else {
			return (
			<div className="col-sm-12 mb-3 status-history anim-slide-in-top">
				<h6 className="text-center text-muted">{ __('None Yet') }</h6>
			</div>
			);
		}
	}
}

function mapStateToProps(state) {
	return { history:state.feedback_detail.status_history }
}

export default connect(mapStateToProps)(StatusHistory)
